import React from "react";
import classNames from "classnames";
import styles from "./video-embedded.module.scss";
import {useLocation} from "react-router-dom";
import {AppStore} from "../../app/app-store";
import useVideoMetadata from "./use-video-metadata";
import {PublisherMicrodataSchema} from "../microdata-schema/publisher-microdata-schema";

export const VideoMicrodataSchema = ({ioc, videoId}) => {
  const metadata = useVideoMetadata(videoId)

  if(!videoId || !metadata) {
    return null
  }

  const location = useLocation();
  const pageUrl = window.location.origin + location.pathname;
  const appStore = ioc.getInstance(AppStore);
  const langCultureName = appStore.state.language.cultureName

  const videoObjectId: String = `${pageUrl}#video-${videoId}`;
  const webpageId: String = `${pageUrl}#webpage`;
  const thumbnailUrl: String = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  const embedUrl: String = `https://www.youtube.com/watch?v=${videoId}`;

  const containerProps = {
    itemScope: true,
    itemType: "https://schema.org/VideoObject",
    itemID: videoObjectId,
    className: classNames(styles.microdata_video_hidden)
  }

  return (
    <div {...containerProps}>
      <meta itemProp="name" content={metadata.title}/>
      <meta itemProp="description" content={metadata.description}/>
      <meta itemProp="uploadDate" content={metadata.publishedAt}/>
      <meta itemProp="duration" content={metadata.duration}/>
      <link itemProp="thumbnailUrl" href={thumbnailUrl}/>
      <link itemProp="embedUrl" href={embedUrl}/>
      <meta itemProp="isFamilyFriendly" content="True"/>

      <PublisherMicrodataSchema/>

      <meta itemProp="inLanguage" content={langCultureName}/>
      <link itemProp="isPartOf" href={webpageId}/>
      <link itemProp="mainEntityOfPage" href={webpageId}/>
    </div>
  );
};
